type BiomethaneIconProps = {
  color?: string;
};

export default function BiomethaneIcon({ color = '#047dba' }: BiomethaneIconProps) {
  return (
    <svg id="Picto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
      <path
        style={{ fill: color }}
        d="M198.86,176.19l-19.56-15.5-2-1.53c-18.36-14.55-45.13-11.45-59.68,6.91l-1.49,1.89,15.64,12.54,15.49-19.55,19.56,15.5h0s.03-.04.03-.04l1.98,1.57c18.36,14.55,45.13,11.45,59.68-6.91l1.49-1.89-15.64-12.54-15.49,19.55Z"
      />
      <path
        style={{ fill: color }}
        d="M54.99,85h0c-12.06,0-23.39,4.7-31.92,13.22-8.53,8.53-13.22,19.86-13.22,31.92v69.71s.02,0,.02,0c0,16.57,13.43,30,30,30h7.97s7.16,0,7.16,0h7.16s0,0,0,0h7.97c16.52,0,29.91-13.35,30-29.84h0v-69.86c0-24.89-20.25-45.14-45.14-45.14ZM80.13,199.84h0v7.28c0,1.5-1.22,2.72-2.72,2.72h-22.41s-22.41,0-22.41,0c-1.5,0-2.72-1.22-2.72-2.72v-7.28h-.02v-69.71c0-6.71,2.62-13.03,7.36-17.78,4.75-4.75,11.06-7.36,17.78-7.36,13.86,0,25.14,11.28,25.14,25.14v69.71Z"
      />
      <path
        style={{ fill: color }}
        d="M31.75,72.87l.03-.04c.39.28.77.56,1.18.81,14.16,8.69,32.35,8.31,46.18-1.14l.02.02c13.17-8.45,14.72-26.83,3.2-37.41l-27.35-25.11-27.34,25.1c-11.82,10.85-9.62,29.43,4.09,37.77ZM41.19,49.83l13.81-12.68,13.83,12.69c1.37,1.26,1.46,2.79,1.39,3.6-.05.59-.35,1.02-.73,1.41l-.13.13c-.36.36-.78.7-1.14,1.13l-13.2,13.05-12.83-12.97c-.24-.26-.47-.48-.69-.69l-1.24-1.25c-.24-.3-.39-.59-.43-.91-.09-.95.06-2.34,1.34-3.51Z"
      />
      <path
        style={{ fill: color }}
        d="M198.86,129.05l-19.56-15.5-2-1.53c-18.36-14.55-45.13-11.45-59.68,6.91l-1.49,1.89,15.64,12.54,15.49-19.55,19.56,15.5h0s.03-.04.03-.04l1.98,1.57c18.36,14.55,45.13,11.45,59.68-6.91l1.49-1.89-15.64-12.54-15.49,19.55Z"
      />
      <path
        style={{ fill: color }}
        d="M147.27,65.95l19.56,15.5h0s.03-.04.03-.04l1.98,1.57c18.36,14.55,45.13,11.45,59.68-6.91l1.49-1.89-15.64-12.54-15.49,19.55-19.56-15.5-2-1.53c-18.36-14.55-45.13-11.45-59.68,6.91l-1.49,1.89,15.64,12.54,15.49-19.55Z"
      />
    </svg>
  );
}

BiomethaneIcon.defaultProps = {
  color: '#047dba',
};
